<template>
  <div id="main">
    <v-index>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>实训</el-breadcrumb-item>
        <el-breadcrumb-item><a style="color: #000000;">实训室审批</a></el-breadcrumb-item>
      </el-breadcrumb>

      <v-weburl-iframe url="train/audit/room/index" />
    </v-index>
  </div>
</template>

<script>
import VIndex from "@/components/common";
import VWeburlIframe from "@/components/weburl-iframe";
export default {
  name: 'TrainAuditBase',
  components: {VWeburlIframe, VIndex}
}
</script>

<style scoped>

</style>
